export const FLOW_GUIDE_ROUTE = "/sleep-study-monitor-flow";

export const FLOW_GUIDE_PATHS = [
  {
    id: "center-download",
    title: "Path A: Center Downloads Raw Case",
    titleTh: "Path A: Center ดาวน์โหลด Raw Case",
    purpose:
      "Use when center must download the raw sleep study ZIP and prepare it for technician scoring.",
    purposeTh:
      "ใช้เมื่อ Center ต้องดาวน์โหลด raw sleep study ZIP และเตรียมไฟล์ให้ Technician score",
    steps: [
      "Set case status to Transferred To Center.",
      "Wait until center raw download and extract are done.",
      "Select Tech Score, then change status to Assigned.",
      "Technician client pulls the case, scores it, and moves the local folder to Done.",
      "Change status to Technician Scored.",
      "Wait until scored files return to /srv/sleep_center/tech_done_from_client.",
      "Recheck that the case is ready, select Doctor, then change status to Assigned to Doctor.",
      "Doctor client pulls the case, reviews/scores it, and moves the local folder to Done.",
      "Change status to Doctor Scored so final files return to center.",
    ],
    stepsTh: [
      "ตั้ง status เป็น Transferred To Center",
      "รอให้ center raw download และ extract เสร็จ",
      "เลือก Tech Score แล้วเปลี่ยน status เป็น Assigned",
      "เครื่อง Technician pull เคสไป score แล้ว move folder เข้า Done",
      "เปลี่ยน status เป็น Technician Scored",
      "รอให้ scored files กลับมาที่ /srv/sleep_center/tech_done_from_client",
      "Recheck ว่าเคสพร้อม เลือก Doctor แล้วเปลี่ยน status เป็น Assigned to Doctor",
      "เครื่อง Doctor pull เคสไป review/score แล้ว move folder เข้า Done",
      "เปลี่ยน status เป็น Doctor Scored เพื่อให้ final files กลับ Center",
    ],
  },
  {
    id: "technician-upload",
    title: "Path B: Outside Technician Scoring",
    titleTh: "Path B: Technician Score เองแล้ว Upload",
    purpose:
      "Both paths start with Transferred To Center. Use Path B when the assigned outside technician downloads and scores independently, then uploads the scored ZIP.",
    purposeTh:
      "ทั้งสอง path เริ่มจาก Transferred To Center ใช้ Path B เมื่อ Technician ภายนอกดาวน์โหลดและ score เอง แล้ว upload scored ZIP",
    steps: [
      "Set case status to Transferred To Center; center downloads the raw case for this path too.",
      "Wait for raw download/extract, then change status to Assigned with the outside technician's name.",
      "The outside technician downloads and scores independently. Their name is not configured on a center client.",
      "Technician/admin uploads the scored ZIP/report in Sleep Study Monitor.",
      "Change status to Technician Scored.",
      "The upload is marked scoreUploadType = technician_scored.",
      "Center downloads scoredsleepstudys/{HN}/{documentId}/{filename} using patients/{HN}/scoredsleepstudy. Missing ZIPs keep the doctor handoff waiting.",
      "Recheck that scored files are ready in /srv/sleep_center/tech_done_from_client.",
      "Select Doctor, then change status to Assigned to Doctor.",
      "Doctor client pulls the case, reviews/scores it, and moves the local folder to Done.",
      "Change status to Doctor Scored so final files return to center.",
    ],
    stepsTh: [
      "ตั้ง status เป็น Transferred To Center โดย Center ดาวน์โหลด raw case สำหรับ path นี้ด้วย",
      "รอ raw download/extract แล้วเปลี่ยนเป็น Assigned โดยเลือกชื่อ Technician ภายนอก",
      "Technician ภายนอกดาวน์โหลดและ score เอง โดยชื่อไม่ได้ตั้งไว้ในเครื่อง client ที่ Center",
      "Technician/เจ้าหน้าที่ upload scored ZIP/report ใน Sleep Study Monitor",
      "เปลี่ยน status เป็น Technician Scored",
      "ไฟล์ upload จะถูกใส่ marker scoreUploadType = technician_scored",
      "Center ดาวน์โหลด scoredsleepstudys/{HN}/{documentId}/{filename} จาก patients/{HN}/scoredsleepstudy หากไม่มี ZIP ให้รอ upload ก่อนส่ง Doctor",
      "Recheck ว่า scored files พร้อมที่ /srv/sleep_center/tech_done_from_client",
      "เลือก Doctor แล้วเปลี่ยน status เป็น Assigned to Doctor",
      "เครื่อง Doctor pull เคสไป review/score แล้ว move folder เข้า Done",
      "เปลี่ยน status เป็น Doctor Scored เพื่อให้ final files กลับ Center",
    ],
  },
];

export const FLOW_GUIDE_MONITOR_STATUS_SECTIONS = [
  {
    key: "case-status",
    title: "Main Case Status",
    titleTh: "สถานะหลักของเคส",
    intro:
      "These are the status values shown in the Sleep Study Monitor table. They tell operators where the case is in the workflow.",
    introTh:
      "สถานะเหล่านี้คือ status หลักที่แสดงในตาราง Sleep Study Monitor เพื่อบอกว่าเคสอยู่ขั้นตอนไหน",
    items: [
      {
        label: "Transferred To Center",
        text:
          "The case has entered the center workflow. Center should download and extract the raw sleep study files before assigning a technician.",
        textTh:
          "เคสเข้าสู่ workflow ของ Center แล้ว ให้ Center download และ extract raw sleep study files ก่อนส่งต่อให้ Technician",
      },
      {
        label: "Assigned",
        text:
          "Select the technician after raw extract is ready for either path. Only center clients configured with that technician's name pull the raw case.",
        textTh:
          "เลือก Technician หลัง raw extract พร้อมสำหรับทั้งสอง path เฉพาะ client ที่ตั้งชื่อ Technician ตรงกันจะ pull raw case",
      },
      {
        label: "Technician Scored",
        text:
          "Technician scoring is finished or a scored upload was provided. Center must confirm scored files are back before sending to doctor.",
        textTh:
          "Technician score เสร็จแล้ว หรือมี scored upload แล้ว ให้ Center ตรวจว่า scored files กลับมาพร้อมก่อนส่งต่อ Doctor",
      },
      {
        label: "Assigned to Doctor",
        text:
          "Doctor is selected and scored files should be ready for doctor review. Do not use this if scored files are still missing.",
        textTh:
          "เลือก Doctor แล้ว และ scored files ควรพร้อมให้ Doctor review ห้ามใช้ถ้ายังไม่มี scored files",
      },
      {
        label: "Doctor Scored",
        text:
          "Doctor review/scoring is finished. Final doctor output returns to center and the monitor can treat the case as complete.",
        textTh:
          "Doctor review/score เสร็จแล้ว final doctor output จะกลับมาที่ Center และเคสถือว่าเสร็จใน Monitor",
      },
    ],
  },
  {
    key: "file-status",
    title: "Download and Extract Status",
    titleTh: "สถานะ Download และ Extract",
    intro:
      "These badges explain whether center has the required sleep study files locally.",
    introTh:
      "Badge กลุ่มนี้บอกว่า Center มีไฟล์ sleep study ที่ต้องใช้ในเครื่องแล้วหรือยัง",
    items: [
      {
        label: "DL: Not Started",
        text:
          "Download has not started yet. For a new transferred case, wait for center automation or check whether the upload/source file exists.",
        textTh:
          "ยังไม่เริ่ม download สำหรับเคสที่เพิ่งส่งเข้า Center ให้รอ automation หรือเช็คว่ามี upload/source file แล้วหรือยัง",
      },
      {
        label: "DL: Waiting Upload",
        text:
          "The monitor cannot download yet because the uploaded ZIP/report file is not available.",
        textTh:
          "Monitor ยัง download ไม่ได้ เพราะยังไม่มี ZIP/report file ที่ upload เข้ามา",
      },
      {
        label: "DL: Downloading",
        text: "Center automation is downloading the file.",
        textTh: "Automation ฝั่ง Center กำลัง download ไฟล์",
      },
      {
        label: "DL: Downloaded",
        text:
          "Center downloaded the file successfully. Next step is extract if the workflow needs ZIP extraction.",
        textTh:
          "Center download ไฟล์สำเร็จแล้ว ขั้นต่อไปคือ extract ถ้า workflow ต้องแตก ZIP",
      },
      {
        label: "DL: Already Exists",
        text:
          "The same file already exists at center, so automation does not need to download it again.",
        textTh:
          "ไฟล์เดียวกันมีอยู่ที่ Center แล้ว automation จึงไม่ต้อง download ซ้ำ",
      },
      {
        label: "DL: Failed",
        text:
          "Download failed. Check the issue table or center logs before moving the status.",
        textTh:
          "Download fail ให้ดู issue table หรือ log ฝั่ง Center ก่อนเปลี่ยน status",
      },
      {
        label: "DL: Disk Space Error / Center Disk Error",
        text:
          "Center does not have enough disk space for the download. Free space first, then let automation retry.",
        textTh:
          "พื้นที่ disk ฝั่ง Center ไม่พอสำหรับ download ให้เคลียร์พื้นที่ก่อน แล้วค่อยให้ automation retry",
      },
      {
        label: "EX: Not Started",
        text:
          "Extract has not started yet. Usually this means the ZIP is not downloaded yet or automation has not reached this case.",
        textTh:
          "ยังไม่เริ่ม extract โดยปกติแปลว่า ZIP ยังไม่ download เสร็จ หรือ automation ยังไม่ถึงเคสนี้",
      },
      {
        label: "EX: Wait Upload",
        text:
          "Extract is waiting because the uploaded ZIP/report file is not available.",
        textTh:
          "Extract ยังรออยู่ เพราะยังไม่มี ZIP/report file ที่ upload เข้ามา",
      },
      {
        label: "EX: Waiting Extract",
        text:
          "The file is ready, and extract is queued but has not started yet.",
        textTh:
          "ไฟล์พร้อมแล้ว และกำลังรอคิว extract แต่ยังไม่เริ่ม",
      },
      {
        label: "EX: Extracting",
        text: "Center automation is extracting the ZIP.",
        textTh: "Automation ฝั่ง Center กำลัง extract ZIP",
      },
      {
        label: "EX: Done",
        text:
          "Extract is complete and the file set is ready for the next handoff.",
        textTh:
          "Extract เสร็จแล้ว และ file set พร้อมสำหรับส่งต่อขั้นตอนถัดไป",
      },
      {
        label: "EX: Partial Error",
        text:
          "Extract completed only partly. Recheck the extracted file set before assigning the case.",
        textTh:
          "Extract สำเร็จบางส่วน ต้อง recheck file set ที่แตกออกมาก่อน assign เคส",
      },
      {
        label: "EX: Error",
        text:
          "Extract failed. Do not assign the case until the extracted file set is correct.",
        textTh:
          "Extract fail ห้าม assign เคสจนกว่า extracted file set จะถูกต้อง",
      },
      {
        label: "EX: Disk Space Error / Center Disk Error",
        text:
          "Center does not have enough disk space to extract the ZIP. Free space before retrying.",
        textTh:
          "พื้นที่ disk ฝั่ง Center ไม่พอสำหรับ extract ZIP ให้เคลียร์พื้นที่ก่อน retry",
      },
    ],
  },
  {
    key: "scored-files",
    title: "Scored Files for Doctor Review",
    titleTh: "Scored Files สำหรับส่งให้ Doctor",
    items: [
      {
        label: "Scored: Wait Upload",
        text: "The outside scored ZIP is missing. Upload it with Upload Scored SS and wait for center download/extract before assigning the doctor.",
        textTh: "ยังไม่มี scored ZIP จาก Technician ภายนอก ให้ใช้ Upload Scored SS แล้วรอ Center download/extract ก่อนส่ง Doctor",
      },
      {
        label: "Scored: Wait Center Download",
        text: "A scored ZIP was uploaded but is not yet prepared at center. Raw files and an earlier client return do not clear this wait.",
        textTh: "มี scored ZIP ที่ upload แล้ว แต่ Center ยังเตรียมไฟล์ไม่เสร็จ raw files หรือ client return ชุดก่อนหน้าไม่ทำให้ผ่านขั้นตอนนี้",
      },
      {
        label: "Review Scored Sources",
        text: "Open Edit to inspect the source and full folder path of each version. Select a doctor and Assigned to Doctor, save, then choose the approved version in the review confirmation. Matching filenames stay separate; deleting one does not complete review.",
        textTh: "เปิด Edit เพื่อตรวจ source และ path เต็มของแต่ละชุด เลือก Doctor และ Assigned to Doctor แล้ว Save จากนั้นเลือกชุดที่อนุมัติในหน้าต่างยืนยัน review ชื่อไฟล์เหมือนกันก็เก็บแยกกัน และการลบชุดหนึ่งไม่ทำให้ผ่าน review",
      },
      {
        label: "Scored: Done",
        text: "The client return or outside upload has been received, and no unresolved source review or pending ZIP blocks the handoff. Recheck the files before assigning the doctor.",
        textTh: "ได้รับ client return หรือ outside upload แล้ว โดยไม่มี source review หรือ ZIP ที่ยังรอเตรียมไฟล์ ให้ recheck ชุดไฟล์ก่อนส่ง Doctor",
      },
    ],
  },
  {
    key: "transfer-status",
    title: "Technician and Doctor Transfer Status",
    titleTh: "สถานะส่งไฟล์ให้ Technician และ Doctor",
    intro:
      "These badges explain whether files are waiting, copied to a client, returned to center, or blocked.",
    introTh:
      "Badge กลุ่มนี้บอกว่าไฟล์กำลังรอส่ง ถูก copy ไป client แล้ว กลับมาที่ Center แล้ว หรือมีปัญหา",
    items: [
      {
        label: "Tech Transfer: Not Started",
        text:
          "Technician transfer has not started. This is normal before the case reaches Assigned, or before automation picks it up.",
        textTh:
          "การส่งไฟล์ให้ Technician ยังไม่เริ่ม เป็นเรื่องปกติก่อนเคสถึง Assigned หรือก่อน automation หยิบเคส",
      },
      {
        label: "Tech Transfer: Ready",
        text:
          "Case is in Assigned and ready for automation to copy raw/extracted files to the technician client.",
        textTh:
          "เคสอยู่ Assigned และพร้อมให้ automation copy raw/extracted files ไปเครื่อง Technician client",
      },
      {
        label: "Tech Transfer: Copied",
        text:
          "The case folder has been copied to the technician computer. Avoid changing technician after this point.",
        textTh:
          "Folder เคสถูก copy ไปเครื่อง Technician แล้ว ควรหลีกเลี่ยงการเปลี่ยน Technician หลังจุดนี้",
      },
      {
        label: "Tech Transfer: Returned",
        text:
          "Technician finished and moved the folder to Done. Scored technician files returned to center.",
        textTh:
          "Technician ทำเสร็จและ move folder เข้า Done แล้ว scored technician files กลับมาที่ Center",
      },
      {
        label: "Doctor Transfer: Not Started",
        text:
          "Doctor transfer has not started. This is normal before the case reaches Assigned to Doctor.",
        textTh:
          "การส่งไฟล์ให้ Doctor ยังไม่เริ่ม เป็นเรื่องปกติก่อนเคสถึง Assigned to Doctor",
      },
      {
        label: "Doctor Transfer: Ready",
        text:
          "Case is in Assigned to Doctor and ready for automation to copy scored files to the doctor client.",
        textTh:
          "เคสอยู่ Assigned to Doctor และพร้อมให้ automation copy scored files ไปเครื่อง Doctor client",
      },
      {
        label: "Doctor Transfer: Copied",
        text:
          "The case folder has been copied to the doctor computer. Avoid changing doctor after this point.",
        textTh:
          "Folder เคสถูก copy ไปเครื่อง Doctor แล้ว ควรหลีกเลี่ยงการเปลี่ยน Doctor หลังจุดนี้",
      },
      {
        label: "Doctor Transfer: Returned",
        text:
          "Doctor finished and moved the folder to Done. Final doctor output returned to center.",
        textTh:
          "Doctor ทำเสร็จและ move folder เข้า Done แล้ว final doctor output กลับมาที่ Center",
      },
      {
        label: "Doctor Transfer: Waiting Scored Files",
        text:
          "Doctor handoff is waiting because scored technician files are not ready yet.",
        textTh:
          "การส่งต่อ Doctor ยังรออยู่ เพราะ scored technician files ยังไม่พร้อม",
      },
      {
        label: "Self Scored",
        text:
          "This is Path B: the technician already scored the case and uploaded scored files.",
        textTh:
          "เป็น Path B: Technician score เองแล้ว upload scored files ขึ้นมา",
      },
      {
        label: "Transfer Error / Disk Error",
        text:
          "Transfer failed or disk space is not enough on center/client. Fix the error before progressing the status.",
        textTh:
          "Transfer fail หรือพื้นที่ disk ฝั่ง Center/client ไม่พอ ให้แก้ error ก่อนขยับ status",
      },
    ],
  },
  {
    key: "summary-labels",
    title: "Summary Cards and Quick Counters",
    titleTh: "การอ่าน Summary Cards และตัวเลขย่อ",
    intro:
      "These short labels appear at the top of Sleep Study Monitor.",
    introTh:
      "คำย่อเหล่านี้อยู่ใน Summary Cards ด้านบนของหน้า Sleep Study Monitor",
    items: [
      {
        label: "DL / EX / Wait",
        text:
          "Downloaded, extracted, and waiting for uploaded file counts in Transferred To Center.",
        textTh:
          "จำนวนเคสที่ download แล้ว, extract แล้ว, และรอ uploaded file ในสถานะ Transferred To Center",
      },
      {
        label: "Need Tech",
        text: "Cases in Assigned status where Tech Score is still not selected.",
        textTh: "เคสสถานะ Assigned ที่ยังไม่ได้เลือก Tech Score",
      },
      {
        label: "Need Doctor",
        text:
          "Cases in Assigned to Doctor status where Doctor is still not selected.",
        textTh: "เคสสถานะ Assigned to Doctor ที่ยังไม่ได้เลือก Doctor",
      },
      {
        label: "Returned",
        text:
          "Technician transfer returned to center. These cases may be ready for doctor handoff after checking scored files.",
        textTh:
          "ไฟล์จาก Technician กลับมาที่ Center แล้ว อาจพร้อมส่งต่อ Doctor หลังตรวจ scored files",
      },
      {
        label: "Self",
        text:
          "Self-scored Path B cases where the scored upload came from technician/admin upload.",
        textTh:
          "เคส Path B ที่เป็น scored upload จาก Technician/เจ้าหน้าที่",
      },
      {
        label: "TR",
        text: "Transfer error count across technician and doctor handoffs.",
        textTh: "จำนวน transfer error ทั้งฝั่ง Technician และ Doctor",
      },
    ],
  },
];

export const FLOW_GUIDE_STATUS_CHECKS = [
  {
    status: "Assigned",
    before: [
      "Tech Score is selected.",
      "Raw extract is done.",
      "Both paths started with Transferred To Center; center client names determine who pulls automatically.",
    ],
    beforeTh: [
      "เลือก Tech Score แล้ว",
      "Raw extract เป็น Done",
      "ทั้งสอง path เริ่มจาก Transferred To Center โดยชื่อที่ตั้งใน client กำหนดว่าใคร pull อัตโนมัติ",
    ],
  },
  {
    status: "Technician Scored",
    before: [
      "Path A: technician finished scoring and moved the folder to Done.",
      "Path B: uploaded file is a scored ZIP/report, not a raw ZIP.",
    ],
    beforeTh: [
      "Path A: Technician score เสร็จและ move folder เข้า Done แล้ว",
      "Path B: ไฟล์ที่ upload เป็น scored ZIP/report ไม่ใช่ raw ZIP",
    ],
  },
  {
    status: "Assigned to Doctor",
    before: [
      "Doctor is selected.",
      "Scored files are ready for doctor review.",
      "Recheck the scored case before sending to doctor.",
      "When both scored sources exist, choose the approved center return, outside upload, or prepared merge in the review confirmation. Unused files are retained.",
    ],
    beforeTh: [
      "เลือก Doctor แล้ว",
      "Scored files พร้อมสำหรับ Doctor review",
      "Recheck scored case ก่อนส่งให้ Doctor",
      "หากมี scored files จากสองแหล่ง ให้เลือกชุดจาก center client, outside upload หรือ merged folder ที่เตรียมไว้ แล้วยืนยัน review ใน Monitor โดยเก็บไฟล์ที่ไม่เลือกไว้",
    ],
  },
  {
    status: "Doctor Scored",
    before: [
      "Doctor reviewed/scored the report.",
      "Doctor moved the local case folder to Done.",
    ],
    beforeTh: [
      "Doctor review/score report เสร็จแล้ว",
      "Doctor move local case folder เข้า Done แล้ว",
    ],
  },
];

export const FLOW_GUIDE_TROUBLESHOOTING = [
  {
    key: "technician-pull",
    title: "Technician computer does not pull a case",
    titleTh: "เครื่อง Technician ไม่ pull เคส",
    checks: [
      "Status is Assigned.",
      "Technician name matches that client computer.",
      "Raw extract is done.",
      "Client disk space is enough.",
    ],
    checksTh: [
      "Status เป็น Assigned",
      "ชื่อ Technician ตรงกับเครื่อง client",
      "Raw extract done แล้ว",
      "Disk space ของ client เพียงพอ",
    ],
  },
  {
    key: "doctor-pull",
    title: "Doctor computer does not pull a case",
    titleTh: "เครื่อง Doctor ไม่ pull เคส",
    checks: [
      "Status is Assigned to Doctor.",
      "Doctor name matches that client computer.",
      "Scored files exist in tech_done_from_client.",
      "doctorTransferStatus is not waiting_scored_files.",
    ],
    checksTh: [
      "Status เป็น Assigned to Doctor",
      "ชื่อ Doctor ตรงกับเครื่อง client",
      "Scored files อยู่ใน tech_done_from_client",
      "doctorTransferStatus ไม่ใช่ waiting_scored_files",
    ],
  },
  {
    key: "scored-upload",
    title: "Center does not download a scored upload",
    titleTh: "Center ไม่ download scored upload",
    checks: [
      "Status is Technician Scored.",
      "Upload has scoreUploadType = technician_scored.",
      "Center disk space is enough.",
    ],
    checksTh: [
      "Status เป็น Technician Scored",
      "Upload มี scoreUploadType = technician_scored",
      "Disk space ของ Center เพียงพอ",
    ],
  },
];
